export const getFullMediaUrl = (relativePath: string | null): string => {
  if (!relativePath) return "";

  // If it's already a full URL, return as is
  if (
    relativePath.startsWith("http://") ||
    relativePath.startsWith("https://")
  ) {
    return relativePath;
  }

  // If it starts with /media/, prepend the base URL
  if (relativePath.startsWith("/media/")) {
    return `https://prodback.connectifyz.com${relativePath}`;
  }

  // If it doesn't start with /, add it
  if (!relativePath.startsWith("/")) {
    return `https://prodback.connectifyz.com/media/${relativePath}`;
  }

  return `https://prodback.connectifyz.com${relativePath}`;
};

export const getProfileImageUrl = (
  image: string | null,
  fallbackInitial?: string
): string => {
  if (image) {
    return getFullMediaUrl(image);
  }

  // Return a placeholder or generate avatar with initials
  if (fallbackInitial) {
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(fallbackInitial)}&background=007AFF&color=fff&size=400`;
  }

  return "https://ui-avatars.com/api/?name=User&background=007AFF&color=fff&size=400";
};
